"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategoryQuickLinks = void 0;

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var getCategoryQuickLinks = function getCategoryQuickLinks(modules, user) {
  var base = (0, _globals.default)('communityUrl') || '';
  var links = [];

  if (modules.includes('CommunityOverviewOpenForAllUsers')) {
    links.push({
      url: "".concat(base, "/community"),
      phrase: {
        m: 'Forum',
        p: 'nav.title.community.overview'
      }
    });
  } else {
    links.push({
      url: "".concat(base, "/"),
      phrase: {
        m: 'Common',
        p: 'nav.title.forum.overview'
      }
    });
  }

  links.push({
    url: "".concat(base, "/activity/recent"),
    phrase: {
      m: 'Common',
      p: 'nav.title.forum.recent.activity'
    }
  });

  if (user.id) {
    links.push({
      url: "".concat(base, "/activity/sincelastvisit"),
      phrase: {
        m: 'Common',
        p: 'nav.title.forum.activity.last.visit'
      }
    });
  }

  links.push({
    url: "".concat(base, "/activity/unanswered"),
    phrase: {
      m: 'Common',
      p: 'nav.title.forum.unanswered.questions'
    }
  });
  return links;
};

exports.getCategoryQuickLinks = getCategoryQuickLinks;